import React, { useState, useEffect } from 'react';
import { executedCommand } from './helpers';
import { toLocaleDateTimeString } from 'helpers/dateHelper';
import DataLoggerHistoryTooltip from './DataLoggerHistoryTooltip';

export const useDataLoggerHistory = (lastActivityStatus, currentLastActivityStatus) => {
    const [isCurrentActivity, setIsCurrentActivity] = useState(false);
    const [sessionHistory, setSessionHistory] = useState({});

    useEffect(() => {
        if (currentLastActivityStatus?.loggerType) {
            setSessionHistory(prev => ({
                ...prev,
                [currentLastActivityStatus.loggerType]: currentLastActivityStatus
            }));
        }
    }, [currentLastActivityStatus]);

    const dataLoggerHistoryTooltip = (index) => {
        if (!lastActivityStatus && Object.keys(sessionHistory).length === 0) {
            return null;
        }
        // If no index is provided, return tooltips for all history items
        if (typeof index === 'undefined') {
            return (lastActivityStatus || []).map((lastActivity, idx) => {
                const commandId = executedCommand(lastActivity?.lastExecutedCommandId);
                const lastExecutedDateTime = toLocaleDateTimeString(lastActivity?.lastExecutedTimestamp);
                return (
                    <DataLoggerHistoryTooltip key={idx} command={commandId} lastExecutedTime={lastExecutedDateTime} />
                );
            });
        }

        const activity = sessionHistory[index] || (lastActivityStatus || []).find(status => status?.loggerType === index);
        if (!activity || !activity?.lastExecutedCommandId) {
            return null;
        }
        const commandId = executedCommand(activity?.lastExecutedCommandId);
        const lastExecutedDateTime = toLocaleDateTimeString(activity?.lastExecutedTimestamp);
        return (
            <DataLoggerHistoryTooltip key={index} command={commandId} lastExecutedTime={lastExecutedDateTime} />
        );
    };

    const currentDataLoggerHistoryTooltip = () => {
        if (!currentLastActivityStatus) {
            return null;
        }
        const commandId = executedCommand(currentLastActivityStatus?.lastExecutedCommandId);
        const lastExecutedDateTime = toLocaleDateTimeString(currentLastActivityStatus?.lastExecutedTimestamp);
        return (
            <DataLoggerHistoryTooltip command={commandId} lastExecutedTime={lastExecutedDateTime} />
        );
    };

    const selectedDataLoggerCommand = (loggerType) => {
        const activity = sessionHistory[loggerType] || (lastActivityStatus || []).find(status => status?.loggerType === loggerType);
        return activity ? executedCommand(activity?.lastExecutedCommandId) : null;
    };

    const currentSelectedDataLoggerCommand = () => {
        return executedCommand(currentLastActivityStatus?.lastExecutedCommandId);
    };

    return {
        isCurrentActivity,
        setIsCurrentActivity,
        dataLoggerHistoryTooltip,
        currentDataLoggerHistoryTooltip,
        selectedDataLoggerCommand,
        currentSelectedDataLoggerCommand
    };
};
